var $ = require("jquery");

(function () {
    if ($(window).width() > 1278) {
        
    }


    $(document).on('click', '[data-nav-toggler]', function () {
        $('.Menu').toggleClass('-open');
        $('body').toggleClass('-freeze');
    });

    $(document).on('click', '[data-nav-close]', function () {
        $('.Menu').removeClass('-open');
      /*  $('body').removeClass('-freeze');*/
    });

    $(document).on('mouseover', function () {
        $('.-dropdownopen').removeClass('-dropdownopen');
    })

    $(document).on('focusin', function (event) {
        if ($(window).width() > 1278) {
            if ($(':focus').data('navItemToggler') !== undefined) {
                $(':focus').closest('[data-nav-item]').addClass('-dropdownopen');
            }
            else {
                if ($(':focus').closest('.Menu-dropdown').length == 0) {
                    $('.-dropdownopen').removeClass('-dropdownopen');
                }
            }
        }
    });

    $(document).on('click', '[data-nav-item-toggler]', function () {
        if ($(window).width() < 1279) {
            var $closestItem = $(this).closest('[data-nav-item]');
            
            if (!$closestItem.hasClass('-open')) {
                $closestItem.children('ul').slideDown('fast', function () {
                    $closestItem.addClass('-open');
                    $closestItem.children('ul').css('display', '');
                });
            }
            else {
                $closestItem.children('ul').slideUp('fast', function () {
                    $closestItem.removeClass('-open');
                    $closestItem.children('ul').css('display', '');
                });
            }
        }
    });
})();

